export default {
	'en': {
		'next': 'Next',
		'confirm': 'Confirm'
	},
	'tc': {
		'next': '下一題',
		'confirm': '確定'
	}
}